import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { TestListComponent } from "../../../test/component/test-list/test-list.component";
import { TrailDetailslComponent } from "../trail-details/trail-details.component";
import { TrailConditionComponent } from "../trail-condition/trail-condition.component";
import { TrailPersonalComponent } from "../trail-personal/trail-personal.component";
import { TrailSetupComponent } from "../trail-setup/trail-setup.component";
import { RecommendationComponent } from "../../../recommendation/component/recommendation/recommendation.component";
import { TrailMachineryComponent } from "../trail-machinery/trail-machinery.component";
import { TrailMainSwitchboardComponent } from "../trail-main-switchboard/trail-main-switchboard.component";
import { TrailControlSystemComponent } from "../trail-control-system/trail-control-system.component";
import { TrailDpSensorComponent } from "../trail-dp-sensor/trail-dp-sensor.component";
import { TrailDocumentCapabilityComponent } from "../trail-document-capability/trail-document-capability.component";
import { TrailDocumentDpEventComponent } from "../trail-document-dp-event/trail-document-dp-event.component";
import { TrailDocumentModificationComponent } from "../trail-document-modification/trail-document-modification.component";
import { TrailDocumentFmeaComponent } from "../trail-document-fmea/trail-document-fmea.component";

@Component({
  selector: 'dpi-trail-hub',
  imports: [MatTabsModule, MatTooltipModule, MatBadgeModule, TestListComponent, TrailDetailslComponent, TrailConditionComponent, 
    TrailPersonalComponent, TrailSetupComponent, RecommendationComponent, TrailMachineryComponent, TrailMainSwitchboardComponent, 
    TrailControlSystemComponent, TrailDpSensorComponent, TrailDocumentCapabilityComponent, TrailDocumentDpEventComponent, 
    TrailDocumentModificationComponent, TrailDocumentFmeaComponent],
  templateUrl: './trail-hub.component.html',
  styleUrl: './trail-hub.component.scss'
})
export class TrailHubComponent {
  testNum: number;
  personNum: number;
  setupNum: number;
  machineryNum: number;
  switchboardNum: number;
  controlSysNum: number;
  dpSensorNum: number;
  docCapabilityNum: number;
  docDpEventNum: number;
  docModificationNum: number;
  docFmeaNum: number;
  recommendationNum: number;

  constructor() {
    this.testNum = 0;
    this.personNum = 0;
    this.setupNum = 0;
    this.machineryNum = 0;
    this.switchboardNum = 0;
    this.controlSysNum = 0;
    this.dpSensorNum = 0;
    this.docCapabilityNum = 0;
    this.docDpEventNum = 0;
    this.docModificationNum = 0;
    this.docFmeaNum = 0;
    this.recommendationNum = 0;
  }

  setTestNum(count: number) {
    this.testNum = count;
  }

  setPersonNum(count: number) {
    this.personNum = count;
  }

  setSetupNum(count: number) {
    this.setupNum = count;
  }

  setMachineryNum(count: number) {
    this.machineryNum = count;
  }

  setSwitchboardNum(count: number) {
    this.switchboardNum = count;
  }
  
  setControlSysNum(count: number) {
    this.controlSysNum = count;
  }

  setDpSensorNum(count: number) {
    this.dpSensorNum = count;
  }

  setDocCapabilityNum(count: number) {
    this.docCapabilityNum = count;
  }

  setDocDpEventNum(count: number) {
    this.docDpEventNum = count;
  }
  
  setDocModificationNum(count: number) {
    this.docModificationNum = count;
  }
    
  setDocFmeaNum(count: number) {
    this.docFmeaNum = count;
  }

  setRecommendationNum(count: number) {
    this.recommendationNum = count;
  }

}
